import React from "react";
import { RadixComboBox } from "./RadixComboBox";
import { findUspsStateOptionByCode, toUspsStateCode, uspsStateOptions, } from "../utility/uspsStates";
var toNormalizedSearchQuery = function (value) {
    return value.trim().toLowerCase();
};
var getStateNameFromCode = function (value) {
    var option = findUspsStateOptionByCode(value);
    return option ? option.name : "";
};
var resolveStateCode = function (value) {
    return toUspsStateCode(value);
};
export var StateCodeComboBox = React.forwardRef(function (props, ref) {
    var id = props.id, value = props.value, onChange = props.onChange, onBlur = props.onBlur, label = props.label, autoComplete = props.autoComplete, ariaInvalid = props.ariaInvalid, ariaDescribedBy = props.ariaDescribedBy;
    var _a = React.useState(getStateNameFromCode(value)), searchQuery = _a[0], setSearchQuery = _a[1];
    var _b = React.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    React.useEffect(function () {
        if (!isOpen) {
            setSearchQuery(getStateNameFromCode(value));
        }
    }, [isOpen, value]);
    var options = React.useMemo(function () {
        var normalizedQuery = toNormalizedSearchQuery(searchQuery);
        var filteredStates = uspsStateOptions.filter(function (option) {
            if (!normalizedQuery) {
                return true;
            }
            var name = option.name.toLowerCase();
            var code = option.code.toLowerCase();
            return name.includes(normalizedQuery) || code.includes(normalizedQuery);
        });
        return filteredStates.map(function (option) { return ({
            value: option.code,
            label: "".concat(option.name, " (").concat(option.code, ")"),
        }); });
    }, [searchQuery]);
    return (React.createElement(RadixComboBox, { id: id, ref: ref, value: value, inputValue: searchQuery, options: options, onInputValueChange: function (nextSearchQuery) {
            var matchedCode = resolveStateCode(nextSearchQuery);
            setSearchQuery(nextSearchQuery);
            if (matchedCode) {
                onChange(matchedCode);
                return;
            }
            onChange("");
        }, onValueChange: function (nextCode) {
            var selectedOption = findUspsStateOptionByCode(nextCode);
            onChange(nextCode);
            setSearchQuery(selectedOption ? selectedOption.name : "");
        }, onOpenChange: setIsOpen, onBlur: function () {
            var matchedCode = resolveStateCode(searchQuery);
            if (matchedCode) {
                var selectedOption = findUspsStateOptionByCode(matchedCode);
                onChange(matchedCode);
                if (selectedOption) {
                    setSearchQuery(selectedOption.name);
                }
            }
            if (onBlur) {
                onBlur();
            }
        }, label: label, autoComplete: autoComplete, noResultsMessage: "No matching states found.", ariaInvalid: ariaInvalid, ariaDescribedBy: ariaDescribedBy }));
});
StateCodeComboBox.displayName = "StateCodeComboBox";
